import moment from 'moment';
import Cookies from 'js-cookie';

export default {
  apiBasePath() {
    // eslint-disable-next-line no-undef
    return process.env.BASE_API;
  },
  webSite() {
    // eslint-disable-next-line no-undef
    return process.env.WEBSITE;
  },
  fuzzyName(name, sexId){
    if(!name){
      return '';
    }
    var firName = name.substring(0, 1);
    let str = firName;
    if(sexId == 2){
      str = firName + '女士';
    } else {
      str = firName + '先生';
    }
    return str;
  },
  calcAge(birthday) {
    var birth = new Date(birthday);
    var ageDifMs = Date.now() - birth.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  },
  formatDate(dateStr) {
    if(!dateStr) return '';
    var m = moment(dateStr);
    if(m.format('YYYY') == 1900){
      return '';
    } else {
      return m.format('YYYY/MM/DD');
    }
  },
  replaceBreakLine(str){
    if(str){
      return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
    return str;
  },
  isMobile(mobile){
    var reg = /^1\d{10}$/;
    return reg.test(mobile);
  },
  isEmail(email) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    return reg.test(email);
  },
  hasMobile(mobile) {
    var reg = /1\d{10}/;
    return reg.test(mobile);
  },
  formatDateYearMonth(dateStr) {
    if(!dateStr) return '';
    var m = moment(dateStr);
    if(m.format('YYYY') == 1900){
      return '至今';
    } else {
      return m.format('YYYY/MM');
    }
  },
  formatDateTime(dateStr) {
    if(!dateStr) return '';
    var m = moment(dateStr);
    if(m.format('YYYY') <= 1900){
      return '';
    } else {
      return m.format('YYYY/MM/DD HH:mm:ss');
    }
  },
  formatDateTime2(dateStr) {
    if(!dateStr) return '';
    var m = moment(dateStr);
    if(m.format('YYYY') <= 1900){
      return '';
    } else {
      return m.format('YYYY/MM/DD HH:mm');
    }
  },
  formatDateTime3(dateStr) {
    var m = moment(dateStr);
    var now = moment();
    var years = now.diff(m, 'year');
    if(years >= 1){
      return '1年前';
    } else {
      return m.format('YYYY/MM/DD HH:mm');
    }
  },
  formatPrice(value) {
    let val = (value / 100).toFixed(2).replace(',', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
  getCookieId(name) {
    let cookieId = Cookies.get(name);
    return cookieId;
  },
  createCookie(name, value, days, domain, cpath) {
    let path = cpath || '',
      expires = '',
      cookieURL = '; path=' + path + '/';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    if (domain) {
      cookieURL = cookieURL + '; domain=' + domain;
    }
    document.cookie = name + '=' + value + expires + cookieURL;
  },
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  },
  getChatTime(dateStr) {
    var m = moment(dateStr);
    if(m.format('YYYY') <= 1900){
      return '';
    }
    var days = moment().diff(dateStr, 'days');
    if (days == 0) {
      return moment(dateStr).format('HH:mm');
    } else if (days == 1) {
      return '昨天';
    } else {
      return moment(dateStr).format('YYYY-MM-DD');
    }
  },
  buildImageContent(imgUrl){
    var imgContent = '<img class="chatimage" src="' + imgUrl + '"></img>';
    return imgContent;
  },
  isImage(imgUrl){
    var reg = /^(http:|https:)(\w|:|\/|\.|:)+(\.jpg|\.jpeg|\.png)$/;
    return reg.test(imgUrl);
  },
  stripHtml(html) {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  },
  removeHref(html){
    var reg = /((href='\S+')|(href="\S+"))/;
    return html.replace(reg, '');    
  }
};